module.exports = __webpack_public_path__ + "media/images/Horizontal Side Shadow for White Box-d9febe1b439ec8010ded7e4dd9dd6ac4.svg";